class MemoryStorage {
  constructor() {
    this.store = {};
  }
  getItem(key) {
    return this.store.hasOwnProperty(key) ? this.store[key] : null;
  }
  setItem(key, value) {
    this.store[key] = String(value);
  }
  removeItem(key) {
    delete this.store[key];
  }
  clear() {
    this.store = {};
  }
}

const safeStorage = (function() {
  const memStore = new MemoryStorage();
  return {
    getItem: (key) => memStore.getItem(key),
    setItem: (key, value) => memStore.setItem(key, value),
    removeItem: (key) => memStore.removeItem(key),
    clear: () => memStore.clear(),
  };
})();

export default safeStorage;
